// Packages
import React, { useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, ListItemAvatar, Avatar, useMediaQuery } from '@mui/material';
import get from 'lodash/get';

// Relatives
import ProfileMenu from '../Menu/ProfileMenu';

import AvatarImg from '../../../styles/images/avatarDefault.png';

const AvatarUser = props => {
  const {
    Special,
    user: { userNGOs, setUserNGO, userNGOSelected, params }
  } = props;
  const isMobile = useMediaQuery('(max-width: 1399px)');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const parentRef = useRef(null);

  const handleMenuClose = () => setIsMenuOpen(false);

  const handleMenuOpen = () => setIsMenuOpen(true);

  // const avatar = useMemo(() => get(params, 'profile.avatar.mediumImage'), [params]);

  const avatar = useMemo(() => get(userNGOSelected, '_misc.avatar.medium_image'), [params]);

  return (
    <>
      <MenuItem className="header-user-item" ref={parentRef} onClick={handleMenuOpen}>
        <ListItemAvatar className="avatar-holder me-3">
          <Avatar alt="Remy Sharp" src={avatar || AvatarImg} className="avatar-image" />
          <div className="d-flex flex-column avatar-name">
            <span className="text-primary">{params.userName}</span>
            <span>{get(userNGOSelected, 'virtual_artist_handle')}</span>
          </div>
        </ListItemAvatar>
      </MenuItem>
      {!isMobile && (
        <ProfileMenu
          specialMenu={Special}
          isOpen={isMenuOpen}
          parentRef={parentRef}
          ngos={userNGOs}
          ngoSelected={userNGOSelected}
          onClose={handleMenuClose}
          onSelectNGO={setUserNGO}
        />
      )}
    </>
  );
};

AvatarUser.defaultProps = {
  user: null,
  Special: true
};

AvatarUser.propTypes = {
  user: PropTypes.object,
  Special: PropTypes.bool
};

export default AvatarUser;
